(function ($) {
    $(window).on("load", function () {
        var className = ".js-hide-date";
        $(className).each(function () {
            var hideDate = $(this).find("p.date").html()
            if (hideDate === "1") {
                var viewName = ".js" + $(this).find("p.viewname").html().replaceAll('/', '_') + " ";
                setTimeout(function () {
                    var sectionClass = $(viewName + " section").attr('class').split(' ')[0];
                    var sectionName = viewName + "." + sectionClass;
                    $(sectionName).addClass("hide-date");
                }, 100);
            }
            setTimeout(function () {
                $(".js-hide-date").remove();
            }, 400);
        });

        var viewClassName = ".space-class";
        $(viewClassName).each(function () {
            var spacingClass = $(this).attr("data-padding").trim();
            if (spacingClass !== "") {
                var sectionClass = $(this).find("section").attr("class"),
                    sectionClassArray = sectionClass.split(" "), i, paddingClass;
                for (i = 0; i < sectionClassArray.length; ++i) {
                    if (sectionClassArray[i].includes('padding')) {
                        paddingClass = sectionClassArray[i]
                        $(this).find("section").removeClass(paddingClass)
                    }
                }
            }
            $(this).find("section").addClass(spacingClass);
            removeDIV($(this));
        });
        function removeDIV(DivClass) {
            var cnt = $(DivClass).contents();
            $(DivClass).replaceWith(cnt);
        }
    });
})(jQuery);